export default __webpack_public_path__ + "static/media/eye.53d8e9c0.svg";